import React from "react";
import HelpDeskMessage from "../../help-desk/helpDeskMessage";

export default function DefaultErrorResponse() {
  return <HelpDeskMessage />;
}
